var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',[_c('v-img',{staticClass:"home-title-image",attrs:{"src":_vm.titleImage}},[_c('div',{staticClass:"pb-5"},[_c('h1',{staticClass:"home-title",domProps:{"innerHTML":_vm._s(_vm.lang['homeText'])}})])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }